'use client';

import { ImagePlugin } from '@platejs/media/react';

import { ImageElement } from '@/components/ui/image-node';

/** Field-tier images: `![alt](url)` — URL only, no upload. */
export const FieldMediaKit = [
  ImagePlugin.configure({
    options: {
      disableUploadInsert: true,
    },
    render: {
      node: ImageElement,
    },
  }),
];
